import { Link } from '@mui/material';
import React from 'react';

const About: React.FC = () => {
  return (
    <div className="aboutPage">
      <h1 className="smallTitle">About</h1>
      <div className="aboutInfoContainer">
        <p>
          Lord Jolt's Champions Guild is a fan-made, third-party open-source
          hiscore tracker for the{' '}
          <Link href="https://rsc.vet" className="link" target="_blank">
            OpenRSC
          </Link>{' '}
          preservation server. While unofficial, it’s approved by the Mod/Admin
          team and safe to use. Contact me in-game or via the OpenRSC Discord
          for questions or suggestions.
        </p>
        <p>
          This tracker was originally created for a week-long Agility event on
          April 2023 hosted by player named Url. It was never used for that, but
          I kept it tracking my overall experience for about seven months. Later
          on I found out that Zooer had been manually tracking hiscores for some
          time. I figured I could expand this and put it in a real use since I
          already had a solid base.
        </p>
        <p>Champions Guild has been online since January 1, 2024.</p>
        <p>
          <Link
            href="https://gitlab.com/zilleville/champions-guild"
            className="link"
            target="_blank"
          >
            GitLab source code
          </Link>
        </p>
        <img
          src="/images/fighting.png"
          alt="Fighting skill icon"
          className="skillIconNoMarginRight"
        />
        Thanks
        <img
          src="/images/fighting.png"
          alt="Fighting skill icon"
          className="skillIconNoMarginRight"
        />
        <ul>
          <li>
            Zooer for giving out lots of ideas and being my personal rubber duck
          </li>
          <li>Apsolutnul for making the awesome skill icons</li>
          <li>
            kRiStOf for linking this to his{' '}
            <Link
              href="https://spinachroll.com"
              className="link"
              target="_blank"
            >
              Spinach Roll
            </Link>{' '}
            kalculators site
          </li>
        </ul>
        <p>
          <span className="redText">';-;'</span> Lord Jolt{' '}
          <span className="redText">';-;'</span>
        </p>
      </div>

      <div className="changeLog">
        <h3 className="smallTitle">Change Log</h3>

        <div className="changeLogContainer">
          <p>21-Aug-2026</p>
          <ul>
            <li>
              When update crashes empty the current top data. Now it kept
              showing the latest successful data.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>05-Jun-2026</p>
          <ul>
            <li>
              rsc.vet updated hiscores page styling and couple of td elements
              were removed. This caused our parser not to read right fields and
              update process crashed. Fixed now.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>16-May-2026</p>
          <ul>
            <li>
              Date selections uses UTC timezone now, same as update process and
              pretty much whole app. So it might not show correct current date
              for you at the moment, but at least it matches the app and its
              data.
            </li>
            <li>
              Updated security and minor updates to both backend and frontend
              dependencies.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>30-Sep-2025</p>
          <ul>
            <li>
              Leaderboards page has new tab Logs which shows new all time
              records for different time periods made by the chosen date
              starting 09/30/2025. It will be mostly Year and some Month records
              but more interesting ones are the Day and maybe Week ones that I
              myself manually check every day if new ones were made. Now I can
              see them straight from the new tab.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>15-Sep-2025</p>
          <ul>
            <li>
              Big backend update under the hood. At the moment the web scraping
              and the creation of new hiscores rows for every 138 active players
              takes max 7 mins. After that the leaderboards calculation process
              takes another 23 minutes or so. Now the whole process takes 7
              mins. This update takes a lot of stress out of the very heavy
              leaderboards calculation process. Previously leaderboards were
              calculated twice a day and offered as a cache variable to UI. Now
              they are saved to database and daily update process only checks
              latest changes whether they affect the previous records. Also the
              calculating process from the start is much faster now if I ever
              have to trigger it after the initial one.
            </li>
            <li>
              TL;DR the app should crash a lot less and shorter times since the
              leaderboards calculation process got a lot faster
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>02-Feb-2025</p>
          <ul>
            <li>
              Fixed an annoying visual bug from the Player Page when changing
              the date from the datepicker didn't update the visible date, even
              though fetching the right data for the selected date
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>11-Jan-2025</p>
          <ul>
            <li>Show year of the record on Records tab on Leaderboards page</li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>12-Nov-2024</p>
          <ul>
            <li>Small fixes here and there but this time something bigger</li>
            <li>
              Inactive player are paused after two weeks of no exp gain. No
              reason to actively track record holders who has quit months ago.
              Tracking of a paused player can be resumed again from the personal
              player profile page. Paused players are listed on the Players page
              separately from the active players
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>24-Jul-2024</p>
          <ul>
            <li>
              Toggle to show TOP 5 / TOP 10 on both Current Top and Records
              Leaderboards tabs
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>28-Apr-2024</p>
          <ul>
            <li>
              Show the differences in levels and ranks on the Leaderboards, just
              like the player page already has. Please let me know if this
              update sucks or needs some adjustments, and I'll see what I can
              do.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>07-Apr-2024</p>
          <ul>
            <li>
              Players' hiscores data can be exported from the player page as a
              CSV or XLSX file
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>23-Mar-2024</p>
          <ul>
            <li>
              I managed to optimize the Leaderboards load times a lot. Normally
              you won't see the effect since it does it only first time and gets
              saved to a cache after that. Heroku restarts the app every 24
              hours so the first one to open the leaderboards after that has to
              wait the calculations.
            </li>
            <li>
              I was getting bit worried since it was getting so slow already
              with this player base and only 3 months in. By the end of the year
              I bet I have to come up with new optimizations also since the data
              gets so big. The Day Record tab is the most brutal one to
              calculate. Also the update process itself is huge bottleneck
              still, it takes about 15 minutes with this 230 players. If OpenRSC
              would serve an API endpoint to fetch them all with one request it
              would be so much faster.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>01-Mar-2024</p>
          <ul>
            <li>
              I removed 49 players from the tracking list who had not gained any
              experience during their entire tracking period, which ranged from
              20 to over 50 days. It's interesting to stalk the high rank
              players, but propably no need for players last logged in like 3
              years ago.
            </li>
            <li>
              I probably won't delete players with records unless they are
              caught cheating or something. However, removing inactive players
              does make the daily update process and overall use of the app
              faster, given there are fewer players to track and data to
              calculate.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>16-Feb-2024</p>
          <ul>
            <li>
              Update crashed again. This time 10 seconds timeout exceeded when
              getting hiscores for a player. I raised the timeout to 30 seconds.
              Not sure if it was slow on rsc.vet part or mine, but since this
              error happened first time I would guess rsc.vet.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>15-Feb-2024</p>
          <ul>
            <li>
              Now also Current Top Leaderboards are cached except other than
              current dates for Day. App may restart occassionally, so the first
              time doing any of the searches will load them and store in cache
              so next page loads will happen fast.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>13-Feb-2024</p>
          <ul>
            <li>
              The update process for the data of February 12th crashed and I had
              to delete all hiscores for that day. That will leave couple days
              empty gap and break players week/month strikes. I'm sorry for
              that.
            </li>
            <li>
              The crash seemed to be caused by a timeout when people loaded the
              very heavy record leaderboards query in midst of an update
              process. Since Records change only once in 24 hours, they are now
              calculated to cache only once right after the update process. This
              way the Records tab will now be very fast, since it returns
              beforehand calculated value.
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>01-Feb-2024</p>
          <ul>
            <li>
              Records tab for Leaderboards. It shows all time records for
              selected time period. Only one entry per player.
            </li>
            <li>Removed 'All time' option from time period selection</li>
            <li>
              Champions Guild has been online for whole one month now, having
              135 tracked players
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>24-Jan-2024</p>
          <ul>
            <li>
              I heard some ppl take screenshots of previous dates to compare
              current leaderboards. I added date selector to Leaderboards and
              Player pages when Day time period selected
            </li>
            <li>
              Reduced the sleep interval between player hiscore updates down to
              2 seconds to make update process faster
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>17-Jan-2024</p>
          <ul>
            <li>
              Added skill icons to Leaderboards page made by our belowed
              community member Apsolutnul
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>16-Jan-2024</p>
          <ul>
            <li>More consistent and new color styles</li>
            <li>
              Current Top tab to Leaderboards, as a hint for Records is coming
              when I'm able to find out how to do it
            </li>
            <li>
              Display the top 5 Leaderboards instead of the previously shown top
              3
            </li>
            <li>
              Reduced the sleep interval between player hiscore updates down to
              5 seconds
            </li>
            <li>Created this About page</li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>13-Jan-2024</p>
          <ul>
            <li>Optimized database queries and added indexes</li>
            <li>
              Find player form since over 80 players being tracked already
            </li>
            <li>Links to player profiles from Leaderboards</li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>09-Jan-2024</p>
          <ul>
            <li>
              Optimized embarrassing terrible and slow Leaderboards page
              database query from 2-3s to 300-500ms
            </li>
            <li>
              Reduced sleep time between fetching players hiscores from 15s to
              10s. Idea is not to burden rsc.vet too much, but with increasing
              amount of players the whole update is taking over 15 minutes
            </li>
            <li>Prevented adding players with a skill total under 150</li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>07-Jan-2024</p>
          <ul>
            <li>
              Semi official launch day when I linked this to OpenRSC discord and
              some 50 players were added right away
            </li>
            <li>
              Leaderboards page which shows current top experience gains for
              Day/Week/Month/Year/All time
            </li>
            <li>
              Bunch of hotfixes since people found ways to add not wanted inputs
              through form
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>05-Jan-2024</p>
          <ul>
            <li>
              New domain, championsguild.fi, in use, replacing the default
              randomly generated string URL provided by Heroku
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>04-Jan-2024</p>
          <ul>
            <li>Compare players page and style refactoring</li>
            <li>
              Lots of small fixes and style refactorings between 01 and 04
            </li>
          </ul>
        </div>

        <div className="changeLogContainer">
          <p>01-Jan-2024</p>
          <ul>
            <li>Initial deploy to Heroku</li>
            <li>
              Ability to add a player and see personal statistics for every
              skill
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
